<template>
  <group-card title="Comment" icon="comment" class="comment-card">
    <div class="table-container" ref="tableContainer">
      <table class="data-table wide">
        <thead>
          <tr>
            <th><code>Time</code></th>
            <th><code>User</code></th>
            <th><code>Tag</code></th>
            <th><code>Comment</code></th>
            <th><code>Done</code></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="comment in application.loan.app_status_comments"
           :key="id(comment)">
            <td>{{ (comment.created_at ? comment.created_at : Date()) | datetime }}</td>
            <td>{{ comment.name | name }}</td>
            <td>Status Comment</td>
            <td>{{ comment.content }}</td>
            <td>
              <md-checkbox
                v-model="comment.completed" disabled></md-checkbox>
            </td>
          </tr>
          <tr :class="{ completed: comment.completed }"
            v-for="comment in application.loan.comments"
           :key="id(comment)">
            <td>{{ (comment.created_at ? comment.created_at : Date()) | datetime }}</td>
            <td>{{ comment.name | name }}</td>
            <td>{{ comment.tag }}</td>
            <td>{{ comment.content }}</td>
            <td>
              <md-checkbox
                v-model="comment.completed"></md-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              {{ Date() | datetime }}
            </td>
            <td>
              {{ new_comment.name | name }}
            </td>
            <td>
              <validated-autocomplete-input
                label="Tag" v-model="section"
                :options="availableSections"
                force
              />
            </td>
            <td>
              <md-field>
                <label>Comments</label>
                <md-textarea v-model="new_comment.content" md-autogrow></md-textarea>
              </md-field>
            </td>
            <td>
              <span class="inline-block-span">
                <md-button class="md-primary md-simple md-just-icon" @click="addListItem" :disabled="!new_comment.content">
                  <md-icon>add</md-icon>
                </md-button>
                <md-tooltip md-direction="top" v-if="new_comment.content">Click to Save</md-tooltip>
                <md-tooltip md-direction="top" v-else>Cannot Save</md-tooltip>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </group-card>

</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import transitions from "@/components/utils/transitions";
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import { newComment } from "@/schema.js";
import axios from 'axios';

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
  },
  data(){
    return {
      transitions,
      new_comment: {
        tag: null,
        content: '',
        completed: false,
        name: {
          first_name: '',
          last_name: '',
        },
      },
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    availableSections: {
      type: Array,
      default: [],
    },
    currentSections: {
      type: String,
      default: '',
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      'userHasRole',
      'user'
    ]),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get(){ return this.value },
      set(application){ this.$emit('input', application) },
    },

    section: {
      get(){
        return this.new_comment.tag || this.currentSections;
      },
      set(value){
        if(this.currentSections != value && this.new_comment.tag == null){
          this.new_comment.tag = value;
        }
      }
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    async addListItem(){
      this.updateComments();
      this.resetComment();
      if (this.application && this.application.loan && this.application.loan.id) {
        const saveResult = await new Promise((resolve, reject) => {
          this.$emit("save_application", resolve, reject);
        });

        if (this.application.loan.status && this.userHasRole('Broker')) {
          const status = this.application.loan.status;
          const isAssignedToBroker = status.stage === 'Broker' && status.status === 'Assigned To Broker';

          if (isAssignedToBroker) {
            await axios.get(`/api/v1/application/${this.application.loan.id}/automatedStatusCheck`);
          }
        }
      }
    },

    updateComments() {
        if (this.new_comment.content) {
            this.new_comment.tag = this.section;
            this.application.loan.comments.push(this.new_comment);
        }
    },
    resetComment(){
      return this.new_comment = {
        tag: null,
        content: '',
        completed: false,
        name: {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
        },
      };
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.tableContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  created(){
    this.resetComment();
  },
  mounted() {
    this.scrollToBottom();
  },
};
</script>

<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";

  .comment-card{
    width: 800px;
    box-shadow: 0px 0px 30px -12px rgba(0, 0, 0, 1);

    & .table-container{
      max-height: 45vh;
      overflow-y: auto;
    }

    & .vertically-centered-content{
      display: flex;
      align-items: center;
    }

    & .completed{
      text-decoration: line-through;
    }

    .inline-block-span {
      display: inline-block;
    }

  }

</style>